mutation OverwriteEditablesWithMasterTemplateScope(
    $overwrites: [InputOverwriteEditableWithMasterTemplateScope]!
    $campaignId: ID!
) {
    overwriteEditablesWithMasterTemplateScope(campaignId: $campaignId, overwrites: $overwrites) {
        _id
    }
}
